import { Group, Modal, Stack } from "@mantine/core";
import { useMemo, useState } from "react";
import TabAnswersItem from "./TabAnswersItem";
import { useLeadsSheetStore } from "../../../../../../../stores/LeadsStore";
import BackButton from "../../../../../../../components/View/BackButton";
import { useNavigate } from "react-router-dom";

const NewReplyModal = () => {
  const loading = useLeadsSheetStore((s) => s.loading);
  const current = useLeadsSheetStore((s) => s.current);
  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const setLoading = useLeadsSheetStore((s) => s.setLoading);

  const [opened, setOpened] = useState(false);

  const navigate = useNavigate();
  const handleClose = () => {
    setOpened(false);

    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("reply");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: false }
    );
  };

  const aboutList = [
    { key: "%last_name%", value: "lastName" },
    { key: "%first_name%", value: "firstName" },
    { key: "%job_title%", value: "jobTitle" },
    { key: "%company%", value: "company" },
    { key: "%phone%", value: "phone" },
    { key: "%contact_image_url%", value: "contact_image_url" },
    { key: "%linkedin_url%", value: "linkedin_url" },
    { key: "%email%", value: "email" },
  ];
  let result = {};

  aboutList.forEach((item) => {
    result[item.value] = current?.properties?.find(
      (x) => x.identifier_placeholder === item.key
    )?.value;
  });

  const item = useMemo(() => {
    if (!loading) {
      const searchParams = new URLSearchParams(location.search);
      let reply = searchParams.get("reply");
      let result = current?.history?.find(
        (x) => x.id === parseInt(reply) && x.history_type === "reply"
      );
      if (result) {
        setOpened(true);
      }

      return result;
    }
    return null;
  }, [current?.history, loading]);

  return (
    opened && (
      <Modal
        opened={opened}
        onClose={handleClose}
        title={
          <>
            Nouvelle réponse de:{" "}
            <b>
              {result?.firstName || " - "} {result.lastName || " - "} ({" "}
              {result?.email} )
            </b>
          </>
        }
        size={"60%"}
      >
        <Stack>
          <TabAnswersItem
            index={0}
            item={item}
            type={item.type}
            about={result}
            current={current}
            setCurrent={setCurrent}
            container={currentContainer}
            setLoading={setLoading}
            isLast={true}
            hideCampaign
            isOnly={true}
            onAnswerSent={handleClose}
          />

          <Group mt={"md"} justify="end">
            <BackButton size="md" onClick={handleClose} />
          </Group>
        </Stack>
      </Modal>
    )
  );
};

export default NewReplyModal;
